import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import Header from '../../components/headers/MainHeader';
import Footer from "../../components/footers/MainFooterWithLinks";
import AnimationRevealPage from "../../components/helpers/AnimationRevealPage";
import Photo from "../../images/img/Правовая информация. КЗ.png";
import { useTranslation } from "react-i18next";

const Container = tw.div`relative `;
const Content = tw.div`max-w-screen-xl mx-auto py-12 lg:py-16`;
const HeadingColumn = tw.div`text-center xl:text-left max-w-lg xl:max-w-none mx-auto xl:mx-0`;

const HeadingTitle = styled.h1`
    ${tw`font-bold text-3xl md:text-2xl lg:text-4xl xl:text-4xl  leading-tight`}
    margin-bottom: 50px;
    color: #2D2D2D;
`;

const GreenLink = styled.a`
    ${tw`text-green-1002`}
    text-decoration: none;
    font-size: 22px;
    line-height: 32px;
    font-weight: normal;
`;

const HeadingDescription = styled.p`
    ${tw.p`my-5 md:text-5xl lg:my-8 text-base text-black xl:text-xl`}
    font-size: 22px;
    line-height: 32px;
    color: #2D2D2D;
    font-weight: normal;
`;

const Break = styled.div`${tw`my-4`}`;
const Number = styled.span`font-size: 22px;`;

export default () => {
    const { t } = useTranslation();

    return (
        <AnimationRevealPage>
            <Header
                heading={t("legal.title")}
                paragraph={t("legal.paragraph")}
                imageSrc={Photo}
                roundedHeaderButton={false}
            />
            <Container>
                <Content>
                    <HeadingColumn>
                        <HeadingTitle>{t("legal.title")}</HeadingTitle>
                        <HeadingDescription>
                            <Break />
                            <Number>1.</Number>{" "}
                            <GreenLink href="/TermsOfService">
                                {t("legal.agreement")}
                            </GreenLink>
                            <Break />
                            <Number>2.</Number>{" "}
                            <GreenLink href="/PublicOffer">
                                {t("legal.offer")}
                            </GreenLink>
                            <Break />
                            <Number>3.</Number>{" "}
                            <GreenLink href="/PrivacyPolicy">
                                {t("legal.privacy")}
                            </GreenLink>
                        </HeadingDescription>
                    </HeadingColumn>
                </Content>
            </Container>
            <Footer />
        </AnimationRevealPage>
    );
};
